import React from "react";
import "./Appraisalsecond.css";

export default function Appraisalsecond() {
  return (
    <section className="Appraisalsecond" aria-labelledby="as-title">
      <div className="Appraisalsecond__container">
        <h2 id="as-title" className="Appraisalsecond__title">
          How Emerald Appraisal Services Works
        </h2>

        <div className="Appraisalsecond__grid">
          {/* Col 1, Row 1 */}
          <article className="Appraisalsecond__item">
            <h3 className="Appraisalsecond__h3">1) Intake & Feasibility</h3>
            <p className="Appraisalsecond__p">
              We start with a brief call to confirm your goal (purchase, refinance, estate, divorce,
              pre-listing, assessment appeal) and the effective date—current or retrospective.
              You'll share the property type, county, and any special circumstances.
            </p>
          </article>

          {/* Col 2, Row 1 */}
          <article className="Appraisalsecond__item">
            <h3 className="Appraisalsecond__h3">2) Scheduling & Access</h3>
            <p className="Appraisalsecond__p">
              We coordinate a convenient inspection time and confirm access details, entry instructions,
              pets, parking, and HOA information (if applicable). If tenants are present, we'll work with
              you to minimize disruption. You'll receive simple prep tips so the visit is efficient and stress-free.
            </p>
          </article>

          {/* Col 1, Row 2 */}
          <article className="Appraisalsecond__item">
            <h3 className="Appraisalsecond__h3">3) Site Visit & Documentation</h3>
            <p className="Appraisalsecond__p">
              We take interior and exterior photos, measure the home per ANSI standards to confirm gross living
              area (GLA), and note materials, condition, and key features. Most inspections take 30 to 60 minutes
              depending on the property.
            </p>
          </article>

          {/* Col 2, Row 2 */}
          <article className="Appraisalsecond__item">
            <h3 className="Appraisalsecond__h3">4) Records & Data Verification</h3>
            <p className="Appraisalsecond__p">
              We compare public records, MLS data, permits, and HOA documents against what we observed.
              Discrepancies (bed/bath count, GLA, condition notes) are reconciled and explained in the report.
              This step ensures the analysis rests on verified, current information.
            </p>
          </article>

          {/* Col 1, Row 3 */}
          <article className="Appraisalsecond__item">
            <h3 className="Appraisalsecond__h3">5) Comparable Sales & Market Analysis</h3>
            <p className="Appraisalsecond__p">
              We select recent, relevant sales that are truly comparable in condition, size, utility, and location.
              Adjustments are supported by paired-sales logic and local market evidence including days on market,
              list-to-sale ratios, and seasonal trends. For 2–4 unit properties, we may incorporate rent and income
              context when it's meaningful to value.
            </p>
          </article>

          {/* Col 2, Row 3 */}
          <article className="Appraisalsecond__item">
            <h3 className="Appraisalsecond__h3">6) Reconciliation & Quality Review</h3>
            <p className="Appraisalsecond__p">
              We reconcile indications from the sales comparison approach and, when relevant, consider
              cost or income perspectives as cross-checks. Every report runs through a documented QA checklist
              for USPAP compliance, internal consistency, and clear commentary that stands up to underwriting.
            </p>
          </article>

          {/* Col 1, Row 4 */}
          <article className="Appraisalsecond__item">
            <h3 className="Appraisalsecond__h3">7) Report Delivery & Timeline</h3>
            <p className="Appraisalsecond__p">
              You receive a lender-ready, plain-language PDF that explains the methodology and adjustments.
              Typical delivery is 3–5 business days after the inspection, with rush options available.
              Emerald Appraisal Services is FHA-approved and serves Pierce, King, Thurston, Lewis, Mason,
              Kitsap, and Snohomish counties.
            </p>
          </article>

          {/* Col 2, Row 4 */}
          <article className="Appraisalsecond__item">
            <h3 className="Appraisalsecond__h3">8) Post-Report Support</h3>
            <p className="Appraisalsecond__p">
              After delivery, we're available to answer questions and provide high-level explanations for
              stakeholders. If a lender or attorney requests clarification or a reconsideration of value,
              we review any new evidence and respond promptly. Our aim is transparency and a report you can
              confidently share.
            </p>
          </article>
        </div>
      </div>
    </section>
  );
}